import React, { useEffect, useState } from 'react';
import '../../Admin1/Pages/admin1.css';
import axios from 'axios';
import Loader from '../../../safreeimg/loader.gif';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import safrelog from '../../../safreeimg/safreelogo.png';

const NotificationAlarmManagment = () => {
    const [alarmData, setAlarmData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [showForm, setShowForm] = useState(false);
    const [selectedOrganisation, setSelectedOrganisation] = useState(null);

    const fetchAlarmDetails = async () => {
        try {
            setLoading(true);
            setError(null);

            const token = localStorage.getItem('token');
            if (!token) {
                setError('No token found');
                setLoading(false);
                return;
            }

            const alarmId = window.location.hash.replace('#', '').trim();
            console.log("Alarm ID:", alarmId);

            const response = await axios.get(`https://api.safree.org/api-v2022/organization/auth/v1/alarm-details/${alarmId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            console.log("API Data:", response.data.data);
            setAlarmData(response.data.data);
        } catch (err) {
            setError('Error fetching data: ' + err.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAlarmDetails();
    }, []);

    const handleView = () => {
        setSelectedOrganisation(alarmData);
        setShowForm(true);
    };

    const closeForm = () => {
        setShowForm(false);
    };

    if (loading) return <div className='loading'><img src={Loader} alt="Loading..." /></div>;
    if (error) return <div>Error: {error}</div>;
    if (!alarmData) return <div>No alarm data found.</div>;

    return (
        <div className="container user-management">
            <div className="row header">
                <div className="col-md-6">
                    <p className="sub-heading">Alarm Management</p>
                </div>
            </div>

            <div className="content-wrapper">
                {/* Displaying Alarm Information in Cards */}
                <div className="alarm-card-container">
                    <div className="alarm-card">
                        <div className='lognotsaf'>
                        <img src={safrelog} alt="Logo" />
                        </div>
                        <p><strong>Name:</strong> {alarmData.userName}</p>
                        <p><strong>Email:</strong> {alarmData.email}</p>
                        <p><strong>Phone:</strong> {alarmData.phoneNumber}</p>
                        <p><strong>Date:</strong> {new Date(alarmData.time).toLocaleDateString()}</p>
                        <p><strong>Reason:</strong> {alarmData.reason || "N/A"}</p>
                        {/* <p><strong>Audio:</strong> No Audio Available</p> */}
                        <button className="btn btn-view" onClick={handleView}>
                            View Location
                        </button>
                    </div>
                </div>
            </div>

            {/* Side Form for Location */}
            <div className={`side-form ${showForm ? 'show' : ''}`}>
                <h3>Location Details</h3>
                {selectedOrganisation && selectedOrganisation.location && (
                    <div>
                        {selectedOrganisation.location.latitude && selectedOrganisation.location.longitude && (
                            <div className="map-container">
                                <MapContainer
                                    center={[
                                        parseFloat(selectedOrganisation.location.latitude),
                                        parseFloat(selectedOrganisation.location.longitude),
                                    ]}
                                    zoom={13}
                                    style={{ height: '300px', width: '100%' }}
                                >
                                    <TileLayer
                                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                    />
                                    <Marker
                                        position={[
                                            parseFloat(selectedOrganisation.location.latitude),
                                            parseFloat(selectedOrganisation.location.longitude),
                                        ]}
                                        icon={new L.Icon({
                                            iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
                                            iconSize: [25, 41],
                                            iconAnchor: [12, 41],
                                        })}
                                    >
                                        <Popup>
                                            <strong>Location:</strong> {selectedOrganisation.location.raw}
                                        </Popup>
                                    </Marker>
                                </MapContainer>
                            </div>
                        )}
                        <p><strong>Raw Location:</strong> {selectedOrganisation.location.raw}</p>
                        <p><strong>Latitude:</strong> {selectedOrganisation.location.latitude}</p>
                        <p><strong>Longitude:</strong> {selectedOrganisation.location.longitude}</p>
                    </div>
                )}
                <button className="btn-cancel" onClick={closeForm}>Close</button>
            </div>
        </div>
    );
};

export default NotificationAlarmManagment;
